import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    SxProps,
} from '@mui/material';
import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { headingFontBold, vars } from '../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../redux/store';
import {
    closeRemoveAdditionalDocDialog,
    unassignAdditionalDoc,
} from '../../../../redux/project/documents/sliceProjectAdditionalDocuments';

/** Styles for Dialog's component. */
const dialogSx: SxProps = {
    '& .MuiDialog-paper': {
        minWidth: '50%',
        py: 1,
    },
};

/** Styles for the */
const buttonSx: SxProps = {
    ...headingFontBold,
    textTransform: 'none',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    color: vars.font,
    padding: '10px 12px',
};

/**
 * Dialog Component that informs the users if the really want to remove the additional document.
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'removeAdditionalDocDialog' });

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    const additionalDoc = useSelector(
        (_store: IAppReduxStore) => _store.projectAdditionalDocs.additionalDocumentToRemove,
    );
    const {
        isAdditionalDocumentRemoved: { loading: additionalRemoveDocumentLoading },
        isRemoveAdditionalDocDialogOpen,
    } = useSelector((_store: IAppReduxStore) => _store.projectAdditionalDocs);

    const handleClose = () => {
        dispatch(closeRemoveAdditionalDocDialog());
    };

    const handleRemoveAdditionalDoc = () => {
        dispatch(
            unassignAdditionalDoc({
                replicaId: additionalDoc.replicaId,
                additionalDocument: additionalDoc.universalId,
                mainDocument: additionalDoc.referencedMainDocId,
            }),
        );
    };

    return (
        <Dialog open={isRemoveAdditionalDocDialogOpen} onClose={handleClose} sx={dialogSx}>
            <DialogTitle sx={{ fontSize: '18px', color: vars.font }}>{t('title')}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: vars.font }}>
                    {t('bodyText', {
                        additionalDocumentName: additionalDoc?.subject,
                    })}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 2 }}>
                <Button
                    disabled={additionalRemoveDocumentLoading}
                    variant={'text'}
                    onClick={handleClose}
                    sx={buttonSx}
                >
                    {t('cancel')}
                </Button>
                <Button
                    loading={additionalRemoveDocumentLoading}
                    variant={'text'}
                    onClick={handleRemoveAdditionalDoc}
                    sx={{ ...buttonSx, color: vars.mainGreen }}
                >
                    {t('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
